module.exports = __webpack_public_path__ + "static/media/PokoroInst.206782fe.png";